if (typeof ProductFlashSale !== 'function') {

  class ProductFlashSale {

    static STORAGE_PREFIX = 'tk-flash-end-';
    static MIN_MS = 60 * 60 * 1000;
    static MAX_MS = 24 * 60 * 60 * 1000;

    static getEndTime(productId) {
      const key = `${ProductFlashSale.STORAGE_PREFIX}${productId}`;
      const stored = localStorage.getItem(key);
      const parsed = stored ? parseInt(stored, 10) : 0;

      if (parsed > Date.now()) {
        return parsed;
      }

      const randomMs = Math.floor(
        Math.random() * (ProductFlashSale.MAX_MS - ProductFlashSale.MIN_MS)
      ) + ProductFlashSale.MIN_MS;
      const end = Date.now() + randomMs;
      localStorage.setItem(key, String(end));
      return end;
    }

    static formatRemaining(ms) {
      const totalSec = Math.max(0, Math.floor(ms / 1000));
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;
      return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
    }

    constructor(root) {
      this.root = root;
      this.productId = root.dataset.productId;
      this.countdownEl = root.querySelector('[data-js-flash-countdown]');
      if (!this.productId || !this.countdownEl) {
        return;
      }
      this.endTime = ProductFlashSale.getEndTime(this.productId);
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const remaining = this.endTime - Date.now();
      if (remaining <= 0) {
        this.endTime = ProductFlashSale.getEndTime(this.productId);
      }
      this.countdownEl.textContent = ProductFlashSale.formatRemaining(this.endTime - Date.now());
    }
  }

  const initProductFlashSale = () => {
    document.querySelectorAll('[data-js-product-price-compact][data-product-id]').forEach((root) => {
      if (!root._flashSaleInit) {
        root._flashSaleInit = true;
        new ProductFlashSale(root);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFlashSale);
  } else {
    initProductFlashSale();
  }
}
